import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import Landing from "@/pages/Landing";
import LandingPreview from "@/pages/LandingPreview";
import Auth from "@/pages/Auth";
import Today from "@/pages/Today";
import Scanner from "@/pages/Scanner";
import Watchlists from "@/pages/Watchlists";
import Heatmap from "@/pages/Heatmap";
import Indices from "@/pages/Indices";
import Platinum from "@/pages/Platinum";
import OpeningAdr from "@/pages/OpeningAdr";
import VaCross from "@/pages/VaCross";
import TfrGold from "@/pages/TfrGold";
import PowerScan from "@/pages/PowerScan";
import Admin from "@/pages/Admin";
import InstrumentDetail from "@/pages/InstrumentDetail";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
            <Toaster theme="dark" position="top-right" richColors />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/preview-1" element={<LandingPreview v={1} />} />
              <Route path="/preview-2" element={<LandingPreview v={2} />} />
              <Route path="/preview-3" element={<LandingPreview v={3} />} />
              <Route path="/login" element={<Auth mode="login" />} />
              <Route path="/register" element={<Auth mode="register" />} />
              <Route path="/app" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route index element={<Navigate to="/app/today" replace />} />
                <Route path="today" element={<Today />} />
                <Route path="scanner" element={<Scanner />} />
                <Route path="watchlists" element={<Watchlists />} />
                <Route path="heatmap" element={<Heatmap />} />
                <Route path="indices" element={<Indices />} />
                <Route path="platinum" element={<Platinum />} />
                <Route path="opening-adr" element={<OpeningAdr />} />
                <Route path="value-area" element={<VaCross />} />
                <Route path="tfr-gold" element={<TfrGold />} />
                <Route path="power-scan" element={<PowerScan />} />
                <Route path="instrument/:id" element={<InstrumentDetail />} />
                <Route path="admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
